import React from "react"

import footerStyles from "./footer.module.scss"

const Footer = () => {
  return (
    <footer className={footerStyles.footer}>
      <h3>Designed & developed by Yazeed AlKhalaf © 2020</h3>
    </footer>
  )
}

export default Footer
